<script context="module" lang="ts">
    class SvelteComponent<T> {}

    export type TTab = {
        label?: string;
        icon?: ComponentType<SvelteComponent<never>>;
        tabButtonSize?: 'small' | 'large' | 'medium' | 'xSmall' | 'xxSmall';
        value: number;
        component: ComponentType<SvelteComponent<never>>;
        tabClass?: string;
        iconProps?: { [key: string]: string | number };
        textProps?: { [key: string]: string | number };
    };
</script>

<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    import Button from '$components/common/button/button.svelte';
    import type { ComponentType, SvelteComponent } from 'svelte';
    export let items: TTab[] = [];
    export let activeTabValue = 1;
    const handleClick = (tabValue: number) => () => (activeTabValue = tabValue);
</script>

<div class="container">
    <ul class="tabs-button-container">
        {#each items as item}
            <li
                class={`${activeTabValue === item.value ? `active` : 'not-active'} ${
                    item.tabClass
                } tab`}
            >
                <Button
                    variant="outline"
                    size={item.tabButtonSize ? item.tabButtonSize : 'small'}
                    on:keypress={handleClick(item.value)}
                    on:click={handleClick(item.value)}
                    icon={item.icon}
                    aria-label={item.label}
                    title={item.label}
                    textProps={{
                        color: item.textProps?.color
                            ? item.textProps.color
                            : activeTabValue === item.value
                            ? $theme.colors.white
                            : $theme.colors.common.text.heading,
                        variant: 'bodyMedium',
                        bold: activeTabValue === item.value ? true : false,
                    }}
                    iconProps={item.iconProps
                        ? item.iconProps
                        : activeTabValue === item.value
                        ? { fill: $theme.colors.white }
                        : { fill: $theme.colors.common.text.heading }}
                    >{#if item.label}
                        {item.label}
                    {/if}
                </Button>
            </li>
        {/each}
    </ul>
</div>
{#each items as item}
    {#if activeTabValue == item.value}
        <div class="box">
            <svelte:component this={item.component} />
        </div>
    {/if}
{/each}

<style>
    .tabs-button-container {
        display: flex;
        flex-wrap: nowrap;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: var(--spacing-16);
        justify-content: center;
        list-style: none;
        overflow: hidden;
    }

    @media (min-width: 769px) {
        .tabs-button-container {
            display: flex;
            padding-left: 0;
            padding-right: 0;
        }
    }

    .tabs-button-container :global(button) {
        border-color: var(--colors-primary-800);
    }

    .not-active :global(button) {
        color: var(--colors-common-text-heading) !important;
    }

    .active :global(button) {
        border-color: var(--colors-primary-500);
        background-color: var(--colors-secondary-900);
    }

    .tabs-button-container :global(button:first-child) {
        margin-right: 16px;
    }

    .tabs-button-container :global(svg) {
        margin-right: 8px;
    }
</style>
